import client from './client';

export const redisInstancesApi = {
  async list(params = {}) {
    const { data } = await client.get('/api/redis-instances', { params });
    return data;
  },

  async get(id) {
    const { data } = await client.get(`/api/redis-instances/${id}`);
    return data;
  },

  async create(instance) {
    const { data } = await client.post('/api/redis-instances', instance);
    return data;
  },

  async update(id, updates) {
    const { data } = await client.patch(`/api/redis-instances/${id}`, updates);
    return data;
  },

  async delete(id) {
    const { data } = await client.delete(`/api/redis-instances/${id}`);
    return data;
  },

  async allocateDb(instanceId, allocation) {
    const { data } = await client.post(`/api/redis-instances/${instanceId}/databases`, allocation);
    return data;
  },

  async updateDb(instanceId, dbId, updates) {
    const { data } = await client.patch(`/api/redis-instances/${instanceId}/databases/${dbId}`, updates);
    return data;
  },

  async removeDb(instanceId, dbId) {
    const { data } = await client.delete(`/api/redis-instances/${instanceId}/databases/${dbId}`);
    return data;
  },
};
